const initialState = {
  selectedCycle:
    localStorage.getItem('selected-cycle') !== 'undefined'
      ? JSON.parse(localStorage.getItem('selected-cycle'))
      : null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SELECTED_CYCLE':
      const { selectedCycle } = action;
      return {
        ...state,
        selectedCycle,
      };
    default:
      return state;
  }
};

export const setSelectedCycle = (selectedCycle) => ({
  type: 'SELECTED_CYCLE',
  selectedCycle,
});
